import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as RecurrencesIcn } from '../../../../icons/recurrences-icon.svg';
import getColorClasses from '../../lib/getColorClasses';

const Recurrences = ({ currentPath }) => {
  const { t } = useTranslation('DOCUMENTS');
  const validPaths = ['/app/recurrences'];

  return (
    <ListItem>
      <Link to="/app/recurrences" className="flex">
        <RecurrencesIcn className={getColorClasses(currentPath, validPaths, true)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('RECURRENCES')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default Recurrences;
